import { styles } from 'consts';
import styled from 'styled-components';

const { whiteDarker, primaryBlack, boxShadow } = styles;

const setOpacity = ({ isVisible }: { isVisible: boolean }) => (isVisible ? 1 : 0);
const setMaxHeight = ({ isVisible }: { isVisible: boolean }) => (isVisible ? '12rem' : '0');
const setVisible = ({ isVisible }: { isVisible: boolean }) => (isVisible ? 'visible' : 'hidden');
const setMargin = ({ isVisible }: { isVisible: boolean }) => (isVisible ? '1.4375rem 0 1.625rem' : 'unset');

export const PaymentNotificationContainer = styled.div<{ isVisible: boolean }>`
  font-size: 0.75rem;
  line-height: 1.25rem;
  width: 100%;
  max-height: ${setMaxHeight};
  margin: ${setMargin};
  padding-bottom: 0.1rem;
  background-color: ${whiteDarker};
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.5rem 0 ${boxShadow};
  opacity: 0;
  opacity: ${setOpacity};
  visibility: ${setVisible};
  transition: opacity 400ms ease-in-out, max-height 400ms ease-in-out;

  p {
    color: ${primaryBlack};
    margin: 0.5rem;
    padding: 0.5rem 0.75rem 0rem 0.75rem;
    text-align: center;
  }

  p.statusbar__paymentNotificationBold {
    font-weight: bold;
    overflow-wrap: break-word;
  }
`;

export const PaymentNotificationBold = styled.p`
  font-weight: bold;
  overflow-wrap: break-word;
`;
